<template>
  <v-container fluid>
    <v-flex>
      <slot name="page-header" />
      <v-row no-gutters class="user-management-root-wrapper">
        <v-col class="user-management-item-wrapper">
          <slot name="user-management-item" class="user-management-item-slot" />
        </v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import './styles/user-management-layout.scss';

@Component
export default class UserManagementLayout extends Vue {}
</script>
